module.exports = __webpack_public_path__ + "static/img/m_role.864cfc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/sy/m_role.png
// module id = PBO8
// module chunks = 7